<template>
  <div class="menu-content">
    <div class="menu-content__up">
      <div class="menu-content__close">
        <span>{{ $t('close') }}</span>
      </div>
      <div class="menu-content__up-voices">
        <!-- <MenuContentLabel label="Know How." :to="'/know-how'" /> -->
        <MenuContentLabel label="Prosecco Collection." :to="'/collection'" />
        <MenuContentLabel :label="$store.state.lang === 'en' ? 'Contact.' : 'Contatti.'" :to="'/contacts'" />
      </div>
    </div>

    <div class="menu-content__inner">
      <div class="menu-content__background">
        <div
          v-for="(image, index) in images"
          :key="index"
          class="menu-content__background-image"
          :class="{ visible: currentImage === index }"
          :style="{ backgroundImage: `url('${image}')` }"
        ></div>
      </div>
      <div class="menu-content__voices">
        <MenuContentLabel
          label="Manifesto."
          :upLabel="$t('manifestoUp')"
          :big="true"
          :to="'/manifesto'"
          @mouseenter.native="updateImage(0)"
        />
        <MenuContentLabel
          label="Social."
          :upLabel="$t('socialUp')"
          :big="true"
          :to="'/social'"
          @mouseenter.native="updateImage(1)"
        />
        <MenuContentLabel
          label="What's New."
          :upLabel="$t('newsUp')"
          :big="true"
          :to="'/whats-new'"
          @mouseenter.native="updateImage(2)"
        />
        <MenuContentLabel
          label="Prosecco."
          upLabel="Collection"
          :big="true"
          :to="'/collection/cuvee-1821'"
          @mouseenter.native="updateImage(3)"
        />
      </div>
      <div class="menu-content__voices-line"></div>
      <div class="menu-content__extra-voices">
        <!-- <MenuContentLabel label="Know How." :to="'/know-how'" /> -->
        <MenuContentLabel label="Prosecco Collection." :to="'/collection'" />
        <MenuContentLabel :label="$store.state.lang === 'en' ? 'Contact.' : 'Contatti.'" :to="'/contacts'" />
      </div>
      <div class="menu-content__voices-line"></div>
    </div>

    <div class="menu-content__down">
      <LanguageSwitch />
      <SoundController />
      <Socials v-if="isMobile" />
    </div>
  </div>
</template>

<script>
import TweenMax from 'gsap/TweenMaxBase';
import engine from '@/scripts/engine';
import cursor from '@/scripts/cursor';
import MenuContentLabel from '@/components/contents/MenuContentLabel.vue';
import LanguageSwitch from '@/components/frame/LanguageSwitch.vue';
import Socials from '@/components/frame/Socials.vue';
import SoundController from '@/components/frame/SoundController.vue';
import { isMobile } from '@/scripts/utils';

export default {
  name: 'MenuContent',

  components: {
    MenuContentLabel,
    LanguageSwitch,
    Socials,
    SoundController,
  },

  data() {
    return {
      currentImage: 0,
      images: [
        '/static/img/menu_1.jpg',
        '/static/img/menu_2.jpg',
        '/static/img/menu_3.jpg',
        '/static/img/menu_4.jpg',
      ],
      isMobile: isMobile(),
    };
  },

  mounted() {
    const menuContentVoices = Array.from(this.$el.querySelectorAll('.menu-content-label'));
    const language = document.querySelector('.language-switch');
    // const socials = document.querySelector('.socials');
    const background = document.querySelector('.menu-content__background');
    const close = document.querySelector('.menu-content__close');
    const lines = Array.from(document.querySelectorAll('.menu-content__voices-line'));
    TweenMax.set(menuContentVoices, { yPercent: 100, autoAlpha: 0 });
    TweenMax.set(language, { yPercent: 100, autoAlpha: 0 });
    // TweenMax.set(socials, { yPercent: 100, autoAlpha: 0 });
    TweenMax.set(close, { yPercent: 100, autoAlpha: 0 });
    TweenMax.set(background, {
      clipPath: 'inset(100% 0% 0.001% 0.002%)',
      webkitClipPath: 'inset(100% 0% 0.001% 0.002%)',
    });
    TweenMax.set(lines, { scaleX: 0 });
    if (window.innerWidth > 768) {
      engine.add(() => this.parallax(), 'render-parallax');
    }
  },

  methods: {
    parallax() {
      const voices = this.$el.querySelector('.menu-content__voices');
      const image = this.$el.querySelector('.menu-content__background');
      const normX = ((window.innerWidth / 2) - 50 - cursor.ref.coords.x) * 0.05;
      const normY = ((window.innerHeight / 2) - 50 - cursor.ref.coords.y) * 0.05;
      voices.style.transform = `translateY(calc(-50% + ${normY}px)) translateX(calc(-50% + ${normX}px))`;
      image.style.transform = `translateY(${normY * 0.5}px) translateX(${normX * 0.5}px)`;
    },
    updateImage(index) {
      this.currentImage = index;
    },
  },
};
</script>

<style lang="scss" scoped>
.menu-content {
  @extend %full;

  @extend %full;
  display: flex;
  align-items: center;
  justify-content: center;

  &__background {
    width: calc((100vw / 32) * 15);
    height: calc((100vh / 18) * 10);
    opacity: 0.8;
    mix-blend-mode: multiply;

    &-image {
      @extend %full;
      background-image: url('/static/img/hero.jpg');
      background-position: center center;
      background-size: cover;
      opacity: 0;

      transition: opacity .3s $inOutCubic;

      &.visible {
        opacity: 1;
      }
    }

    @include mq($until: ipadL) {
      display: none;
    }
  }

  &__close {
    color: $color-gray;
    font-size: rem(22px);
    font-size: $font-size-text;

    @include mq($until: ipadL) {
      position: absolute;
      top: 72px;
      right: 50px;
    }

    @include mq($until: ipadP) {
      position: absolute;
      top: 53px;
      right: 50px;
    }
  }

  &__up {
    position: absolute;
    top: 0px;
    left: calc((100vw / 32) * 6);
    right: calc((100vw / 32) * 4);
    width: calc(100% - ((100vw / 32) * 10));
    padding-top: calc((100vh / 18) * 1);

    display: flex;
    align-items: center;
    justify-content: space-between;

    @include mq($until: ipadP) {
      justify-content: flex-end;
    }

    &-voices {
      display: flex;
      align-items: center;
      justify-content: space-between;

      @include mq($until: ipadL) {
        display: none;
      }
    }
  }

  &__inner {
    @include mq($until: ipadL) {
      width: calc(100% - ((100vw / 32) * 8));
      padding-top: 80px;
      display: flex;
      align-items: stretch;
      justify-content: center;
      flex-direction: column;
    }
  }

  &__voices {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 80vw;
    transform: translateX(-50%) translateY(-50%);
    display: flex;
    align-items: baseline;
    justify-content: space-between;

    @include mq($until: ipadL) {
      position: static;
      width: 100%;
      flex-direction: column;
      left: calc((100vw / 32) * 4);
      transform: translateX(0%) translateY(0%);
      padding-bottom: calc((100vh / 18) * 1);
    }

    &-line {
      display: none;
      width: 100%;
      height: 1px;
      background-color: $color-primary;

      @include mq($until: ipadL) {
        display: block;
      }
    }
  }

  &__extra-voices {
    display: none;

    @include mq($until: ipadL) {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      padding-top: calc((100vh / 18) * 0.5);
      padding-bottom: calc((100vh / 18) * 0.5);
    }

    .menu-content-label {
      margin: 10px 0px;
    }
  }

  &__down {
    position: absolute;
    bottom: 0px;
    right: calc((100vw / 32) * 4);
    left: calc((100vw / 32) * 5);
    width: calc(100% - ((100vw / 32) * 9));
    padding-bottom: calc((100vh / 18) * 1);

    display: flex;
    align-items: flex-end;
    justify-content: space-between;

    @include mq($until: ipadP) {
      left: calc((100vw / 32) * 4);
    }
  }
}
</style>
